export default "__VITE_ASSET__DZT8TcuG__"